export default {
  IS_LOADING: false
}
